import type { WeightingFunction } from "./WeightingFunction";
import type { WeightingFunctionFactory } from "./WeightingFunctionFactory";

/**
 * Makes box filter function.
 * A Box filter is an equal weighting function (all weights equal).
 * DO NOT LIMIT results by support or resize point sampling will work as it requests points beyond its normal 0.0
 * support size.
 *
 * @see https://imagemagick.org/api/MagickCore/resize_8c_source.html#l00181 Box filter function at ImageMagick source
 */
export class BoxFactory implements WeightingFunctionFactory {
  /**
   * Creates box() weighting function.
   */
  create(): WeightingFunction {
    return function box(): 1 {
      return 1;
    };
  }
}
